import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from '@clientma/shell';
import { ToastProvider } from '@clientma/ui';

import ProviderApp from './ProviderApp';

/**
 * The provider console's entry point.
 *
 * No SessionProvider: an operator is not a member of a tenant, and the console builds its own
 * API client around the provider token instead.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <ErrorBoundary>
        <ProviderApp />
      </ErrorBoundary>
    </ToastProvider>
  </StrictMode>,
);
